import {
  Directive,
  ElementRef,
  HostBinding,
  Inject,
  Input,
  OnInit,
  Renderer2,
} from '@angular/core';
import { FormControlDirective, FormControlName, FormControlStatus, NgModel } from '@angular/forms';

import { VALIDATION_CONTEXT, ValidationContextDirective } from './validation-context.directive';

export type NgControlDirective = FormControlDirective | FormControlName | NgModel;

@Directive({
  selector: '[appFormControl]',
  standalone: false,
})
export class FormControlClassDirective implements OnInit {
  @Input() novalidate = false;

  @HostBinding('class.is-pending')
  get pending() {
    return !this.novalidate && this.is('PENDING');
  }

  @HostBinding('class.is-invalid')
  get invalid() {
    return !this.novalidate && this.validationContext.touched && this.is('INVALID');
  }

  @HostBinding('class.is-valid')
  get valid() {
    // Don't add class if it's empty and optional
    return (
      !this.novalidate &&
      this.validationContext.touched &&
      this.validationContext.hasValue &&
      !this.isCheck &&
      this.is('VALID')
    );
  }

  isCheck = false;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef<HTMLElement>,
    @Inject(VALIDATION_CONTEXT) private validationContext: ValidationContextDirective,
  ) {}

  ngOnInit() {
    switch (this.el.nativeElement?.tagName.toLowerCase()) {
      case 'textarea':
        this.renderer.addClass(this.el.nativeElement, 'form-control');
        break;
      case 'select':
        this.renderer.addClass(this.el.nativeElement, 'form-select');
        break;
      case 'input':
        if (['checkbox', 'radio'].includes((this.el.nativeElement as HTMLInputElement).type)) {
          this.isCheck = true;
        } else {
          this.renderer.addClass(this.el.nativeElement, 'form-control');
        }
        break;
    }
  }

  is(status: FormControlStatus) {
    return this.validationContext.status === status;
  }
}
